// extracted by css-extract-rspack-plugin
export default {"indexCard":"IndexCard-module__indexCard__ugUfl"};